import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import { Grid, Divider, Button, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import AcUnitIcon from "@mui/icons-material/AcUnit";

export default function CustomizedDialogs(props) {
  const { LabID, InstanceID } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");
    return startDate3;
  }

  function DateTime2(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  const [instancelog, setinstancelog] = React.useState([]);

  React.useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manuallabinstanceactivelog/${LabID}/${InstanceID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelog(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [LabID, InstanceID]);

  return (
    <div>
      <Tooltip title="Active Log" arrow>
        <Button
          sx={{
            mx: 1,
            width: { xs: '75px', sm: '85px' },
            height: { xs: '23px', sm: '25px' },
            borderRadius: '50px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            fontSize: { xs: '0.65rem', sm: '0.875rem' },
            padding: { xs: '3px 5px', sm: '4px 8px' },
          }}
          variant="contained"
          color="primary"
          onClick={handleClickOpen}
          aria-label="Open active log"
        >
          Log
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        scroll="paper"
        open={open}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Chip
            icon={<AcUnitIcon />}
            label="Active log"
            clickable
            color="primary"
          />
        </DialogTitle>
        <DialogContent dividers>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                UTC time is displayed here.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={2.4}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.7rem', sm: '0.875rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    Channel
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.7rem', sm: '0.875rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    Status
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.7rem', sm: '0.875rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    Date
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.7rem', sm: '0.875rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    Time
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.7rem', sm: '0.875rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    Executed by
                  </Typography>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>

            {instancelog.map((actdata) => {
              return (
                <React.Fragment>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={2.4}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontSize: { xs: '0.7rem', sm: '0.875rem' }
                          }}
                        >
                          {actdata.channel}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2.4}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontSize: { xs: '0.7rem', sm: '0.875rem' }
                          }}
                        >
                          {actdata.action}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2.4}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontSize: { xs: '0.7rem', sm: '0.875rem' }
                          }}
                        >
                          {DateTime1(`${actdata.date}`)}
                        </Typography>
                      </Grid>
                      {actdata.time === "" ? (
                        <Grid item xs={12} sm={2.4}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: { xs: '0.7rem', sm: '0.875rem' }
                            }}
                          >
                            NA
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={2.4}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: { xs: '0.7rem', sm: '0.875rem' }
                            }}
                          >
                            {DateTime2(`${actdata.date}`, `${actdata.time}`)}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={2.4}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontSize: { xs: '0.7rem', sm: '0.875rem' },
                            wordBreak: 'break-word'
                          }}
                        >
                          {actdata.email.split('@')[0]}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider />
                </React.Fragment>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}